import React, { useEffect, useState } from "react";
import { Col, Row, Form } from '@themesberg/react-bootstrap';
import { getAllBanks } from "../../../../../../controller/api/bank";
import { FULL_LIST_ITEM_PER_PAGE } from "../../../../../../helper/helper";
import { useCookies } from "react-cookie";

export const EditAccountForm = (props) => {
  const { accountData } = props;
  const [listBank, setListBank] = useState([])
  const [cookies] = useCookies(['lottmekong'])

  // Initialize form with existing data
  const [formData, setFormData] = useState({
    name: accountData?.name || '',
    accountName: accountData?.accountName || '',
    accountNumber: accountData?.accountNumber || '',
    bankId: accountData?.bankId || 0
  });

  useEffect(() => {
    const getParamsFunc = async () => {
      const response = await getAllBanks(cookies.lottmekong, 0, FULL_LIST_ITEM_PER_PAGE)

      if (response && response.data && response.data.length > 0) {
        const res = {
          data: response.data,
          total: response.total
        }
        
        setListBank(res.data || [])
        
        // Set initial bank if not already set
        if (!formData.bankId && res.data.length > 0) {
          const initialBankId = accountData?.bankId || res.data[0].id;
          setFormData(prev => ({ ...prev, bankId: initialBankId }));
          props.setBank(initialBankId);
        }
      }
    }
    getParamsFunc()
  }, [cookies.lottmekong, accountData])

  // Update parent component when form data changes
  useEffect(() => {
    props.setName(formData.name);
    props.setAccountName(formData.accountName);
    props.setAccountNumber(formData.accountNumber);
    props.setBank(formData.bankId);
  }, [formData, props]);

  const onNameChange = (evt) => {
    const value = evt.target.value;
    setFormData(prev => ({ ...prev, name: value }));
  }
  
  const onAccountNameChange = (evt) => {
    const value = evt.target.value;
    setFormData(prev => ({ ...prev, accountName: value }));
  }

  const onAccountNumberChange = (evt) => {
    const value = evt.target.value;
    setFormData(prev => ({ ...prev, accountNumber: value }));
  }

  const onBankSelect = (evt) => {
    const value = evt.target.value;
    setFormData(prev => ({ ...prev, bankId: value }));
  }

  return (
    <Form>
      <Row>
        <Col md={12} className="mb-2">
          <Form.Group id="firstName">
            <Form.Label>Tên tài khoản</Form.Label>
            <Form.Control 
              required 
              type="text" 
              placeholder="Nhập tên tài khoản" 
              value={formData.name}
              onChange={onNameChange} 
            />
          </Form.Group>
        </Col>
      </Row>
      <Row>
        <Col sm={12} className="mb-3">
          <Form.Group className="mb-2">
            <Form.Label>Chọn ngân hàng</Form.Label>
            <Form.Select 
              id="bank-id" 
              value={formData.bankId} 
              onChange={onBankSelect}
            >
              {listBank.map(item => (
                <option key={item.id} value={item.id}>
                  {(item.shortName || '') + ' - ' + (item.viName || item.name || '')}
                </option>
              ))}
            </Form.Select>
          </Form.Group>
        </Col>
      </Row>
      <Row>
        <Col sm={12} className="mb-3">
          <Form.Group id="addressNumber">
            <Form.Label>Chủ tài khoản</Form.Label>
            <Form.Control 
              required 
              type="text" 
              placeholder="Nhập tên chủ tài khoản" 
              value={formData.accountName}
              onChange={onAccountNameChange} 
            />
          </Form.Group>
        </Col>
      </Row>
      <Row>
        <Col sm={12} className="mb-3">
          <Form.Group id="addressNumber">
            <Form.Label>Số tài khoản</Form.Label>
            <Form.Control 
              required 
              type="number" 
              placeholder="Nhập số tài khoản" 
              value={formData.accountNumber}
              onChange={onAccountNumberChange} 
            />
          </Form.Group>
        </Col>
      </Row>
    </Form>
  );
};
